<ng-template [ngIf]="displayMode === 'default'">
  <div *ngIf="item && show"
       class="content-card media-card"
       [class.show]="show"
       [class.inline]="inline"
       [class.active]="active"
       itemscope [attr.itemtype]="schemaOrgItemtype">

    <app-content-meta [meta]="meta"></app-content-meta>

    <div *ngIf="canClose" class="close-btn" (click)="closeCard()">
      <app-icon class="close-btn-icon" icon="close"></app-icon>
    </div>

    <div *ngIf="item.advertisement"
         style="
        background-color: #bebebe;
        color: rgba(255, 255, 255, 1);
        font-size: 13px;
        display: table;
        margin-bottom: 2px;
        margin-right:
        20px; padding: 0 3px;
        border-radius: 2px;
        width: max-content;">реклама
    </div>

    <ng-container *ngTemplateOutlet="video"></ng-container>

    <ng-container *ngTemplateOutlet="audio"></ng-container>

    <ng-container *ngTemplateOutlet="image"></ng-container>

    <ng-container *ngTemplateOutlet="metaLinks"></ng-container>

    <app-author-info [user]="author"></app-author-info>

    <ng-container *ngTemplateOutlet="descriptionTemplate"></ng-container>

    <ng-template [ngIf]="item">
      <app-share-and-stats [content_id]="item.id"
                           [stats]="item.stats"
                           [visit_info]="item.visit_info"
                           (shared)="onCopied($event)"
                           (changed)="onShareAndStatsChange($event)">
      </app-share-and-stats>

      <app-content-comments [content]="item"
                            (commented)="setIsCommented()"
                            (changed)="onCommentsChange($event)">
      </app-content-comments>
    </ng-template>
  </div>
</ng-template>

<ng-template [ngIf]="displayMode === 'content_page'">
  <div *ngIf="item && show"
       class="content-card-content-page"
       itemscope [attr.itemtype]="schemaOrgItemtype">

    <app-content-meta [meta]="meta"></app-content-meta>

    <ng-container *ngTemplateOutlet="video"></ng-container>

    <ng-container *ngTemplateOutlet="image"></ng-container>

    <div class="meta">
      <ng-template [ngIf]="isAudio && isBrowser && isAccessGranted">
        <ng-container *ngTemplateOutlet="imgWrap"></ng-container>
      </ng-template>
      <ng-container *ngTemplateOutlet="metaLinks"></ng-container>
    </div>

    <app-author-info [user]="author"></app-author-info>

    <ng-container *ngTemplateOutlet="descriptionTemplate"></ng-container>

    <ng-container *ngTemplateOutlet="audio"></ng-container>

    <app-share-and-stats [content_id]="item?.id"
                         [stats]="item?.stats"
                         [visit_info]="item?.visit_info"
                         (shared)="onCopied($event)"
                         (changed)="onShareAndStatsChange($event)">
    </app-share-and-stats>

    <app-content-comments [content]="item"
                          (commented)="setIsCommented()"
                          (changed)="onCommentsChange($event)">
    </app-content-comments>
  </div>
</ng-template>

<ng-template #metaLinks>
  <div class="meta-links">
    <ng-template [ngIf]="!deviceService.isDesktop()">
      <ng-container *ngTemplateOutlet="toolBar"></ng-container>
    </ng-template>
    <h1 class="title"><a [routerLink]="isMeVersion() ? null : contentRoute(item)">{{ title }}</a></h1>
    <h2 class="subject-wrap">
      <a *ngIf="subjectRoute" [routerLink]="isMeVersion() ? null : subjectRoute" class="subject">{{ subject }}</a>
      <span *ngIf="!subjectRoute" class="subject">{{ subject }}</span>

      <ng-template [ngIf]="item?.subject?.category_id === subjectCategoryEnum.native_language">
        <span class="subject-category">{{ 'content-mini-card.native' | translate }}</span>
      </ng-template>
    </h2>

    <h3 class="subtitle" *ngIf="item.sub_title"><a [routerLink]="isMeVersion() ? null : contentRoute(item)">{{ sub_title }}</a></h3>
    <h4 class="type-and-level">
      <a *ngIf="contentTypeRoute" [routerLink]="isMeVersion() ? null : contentTypeRoute"
         [attr.title]="(contentTypeTitle | translate) + ', ' + (level)">
        {{ contentTypeTitle | translate }}, {{ level }}
      </a>
      <span *ngIf="!contentTypeRoute">{{ contentTypeTitle | translate }}, {{ level }}</span>
    </h4>
    <ng-template [ngIf]="displayMode === 'default'">
      <ng-container *ngTemplateOutlet="toolBar"></ng-container>
    </ng-template>
  </div>
</ng-template>

<ng-template #imgWrap>
  <div class="img-wrap">
    <on-ui-cover [cover]="cover" [attr.data-test] = "'coverImg'"></on-ui-cover>
  </div>
</ng-template>

<ng-template #descriptionTemplate>
  <p *ngIf="description" class="description">
    <span [innerHTML]="description | striptags | nl2br" itemprop="description"></span>
    <ng-template [ngIf]="isBrowser && isCutable">
      <span class="description description--more" (click)="toggleCut()">
        {{ (state.cut ? 'library.read-more' : 'library.read-hide') | translate }}
      </span>
    </ng-template>
  </p>
</ng-template>

<ng-template #video>
  <ng-template [ngIf]="isVideo && isBrowser && isAccessGranted">
    <iframe *ngIf="state.isMediaPrepared"
            width="auto"
            height="auto"
            [src]="safeMediaUrl"
            title="video"
            frameborder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
            class="video">
    </iframe>
  </ng-template>
</ng-template>

<ng-template #audio>
  <ng-template [ngIf]="isAudio && isBrowser && isAccessGranted">

    <div class="podcast-card" *ngIf="deviceService.isDesktop()">
      <on-ui-cover [cover]="cover"
                   class="podcast-card-background"
                   [withBlur]="true"
                   data-test="podcast-image"></on-ui-cover>
      <div class="podcast-card-audio">
        <div class="podcast-card-audio-img">
          <on-ui-cover [cover]="cover"
                       data-test="podcast-image"></on-ui-cover>
        </div>
        <div class="podcast-card-audio-player">
          <on-ui-audio-player [audioPlayerConfig]="audioPlayerConfig"></on-ui-audio-player>
        </div>
      </div>
    </div>

    <on-ui-audio-player *ngIf="!deviceService.isDesktop()"
      [audioPlayerConfig]="audioPlayerConfig"></on-ui-audio-player>

    <div *ngIf="!state.isMediaPrepared">{{ 'library.card-media-audio-not-ready' | translate }}</div>
  </ng-template>
</ng-template>

<ng-template #image>
  <ng-template [ngIf]="isImage && isAccessGranted">
    <div class="content-image content-image-cut" *ngIf="state.isBigImage" (click)="showFullImage()">
      <div class="content-image-cut-bg" *ngIf="imageUrl" [lazyLoad]="imageUrl"></div>
      <img *ngIf="imageUrl && isBrowser"
           [lazyLoad]="imageUrl"
           [attr.alt]="fullTitle" [attr.title]="fullTitle" class="media-card__content">
      <img *ngIf="imageUrl && !isBrowser"
           [src]="imageUrl"
           [attr.alt]="fullTitle" [attr.title]="fullTitle" class="media-card__content">
    </div>
    <div class="content-image" *ngIf="!state.isBigImage">
      <img *ngIf="imageUrl"
           [lazyLoad]="imageUrl"
           [attr.alt]="fullTitle"
           [attr.title]="fullTitle"
           class="media-card__content">
    </div>
  </ng-template>
</ng-template>

<ng-template #toolBar>
  <div class="toolbar" *ngIf="isBrowser">
    <div class="copied-informer" [class.active]="state.copied"><span>{{'invite-card.link-copied' | translate}}</span></div>
    <app-bookmark [item]="item" type="content" (favoriteChanged)="onFavoriteChanged()"></app-bookmark>
    <ng-container *ngTemplateOutlet="menuTemplate"></ng-container>
  </div>
</ng-template>

<ng-template #menuTemplate>
  <on-ui-card-menu [item]="item">
    <a class="menu-item"
       *ngIf="isAuthor"
       [routerLink]="['/constructor/edit', item.id]">
      {{ 'library.menu-edit' | translate }}</a>
    <a class="menu-item warn"
       *ngIf="!isAuthor && isModerator"
       [routerLink]="['/constructor/edit', item.id]">[⚠️] Edit</a>
    <a class="menu-item warn"
       *ngIf="item.purl" [href]="item.purl">[⚠️] Panel</a>
    <div class="menu-item"
         *ngIf="state.subscribed"
         (click)="unsubscribe()">{{ 'library.menu-unsubscribe' | translate }}</div>
    <div *ngIf="isAvailableStatistics" class="menu-item" #shareLinkRef>
      <button type="button"
              [ngxClipboard]
              [cbContent]="contentUrl"
              (cbOnSuccess)="onCopied($event)"
              [container]="shareLinkRef">{{ 'library.menu-share' | translate }}<!-- Поделиться -->
      </button>
    </div>
    <div class="menu-item"
         *ngIf="!isAuthor && isAccessGranted"
         (click)="openComplainForm()">{{ 'library.menu-complain' | translate }}<!-- Пожаловаться --></div>
  </on-ui-card-menu>
</ng-template>

<app-modal *ngIf="imageUrl && state.showFullImage"
           [canClose]="false"
           [scale]="true"
           (closed)="hideFullImage()" class="modal-full-image">
  <app-modal-body>
    <img *ngIf="imageUrl" [lazyLoad]="imageUrl"
         [attr.alt]="fullTitle" [attr.title]="fullTitle" style="display: block; margin: 0 auto;">
  </app-modal-body>
</app-modal>

<app-modal *ngIf="state.complainFormOpened && deviceService.isDesktop()"
           (closed)="closeComplainForm()"
           canClose="true"
           middle="true">
  <app-modal-body>
    <app-complaint-form [type]="'content'"
                        (cancel)="closeComplainForm()">
    </app-complaint-form>
  </app-modal-body>
</app-modal>

<app-mobile-modal *ngIf="state.complainFormOpened && !deviceService.isDesktop()"
                  [titleVisible]="false"
                  (closed)="closeComplainForm()">
  <app-mobile-modal-body>
    <app-complaint-form [type]="'content'"
                        (cancel)="closeComplainForm()">
    </app-complaint-form>
  </app-mobile-modal-body>
</app-mobile-modal>
